/* eslint import/prefer-default-export: 0 */

import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem, isCachedCollection } from '../utils/caching'

import {
  LIST_ALERT_RULES_REQUEST, LIST_ALERT_RULES_RESPONSE,
  SAVE_ALERT_RULE_REQUEST, SAVE_ALERT_RULE_RESPONSE,
  LIST_ALERT_TYPES_REQUEST, LIST_ALERT_TYPES_RESPONSE,
} from '../constants'

export function listAlertTypes() {
  return (dispatch, getState) => {
    if (isCachedCollection(getState().alertTypes)) {
      return
    }

    dispatch({ type: LIST_ALERT_TYPES_REQUEST })

    axios.get(`${CONFIG.apiBase}/alert_types`).then((response) => {
      dispatch({
        type: LIST_ALERT_TYPES_RESPONSE,
        alertTypes: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function listAlertRulesByUnit(id) {
  const unitId = parseInt(id, 10)

  function getLoaderId(action) {
    return action.unitId
  }

  return (dispatch, getState) => {
    if (isCachedItem(getState().alertRulesByUnit, unitId)) {
      return
    }

    dispatch({
      type: LIST_ALERT_RULES_REQUEST,
      unitId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/units/${unitId}/alertrules`).then((response) => {
      dispatch({
        type: LIST_ALERT_RULES_RESPONSE,
        unitId,
        getLoaderId,
        rules: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function saveAlertRule(rule) {
  return (dispatch) => {
    dispatch({ type: SAVE_ALERT_RULE_REQUEST, rule })
    axios.put(`${CONFIG.apiBase}/alertrules/${rule.id}`, rule).then((response) => {
      dispatch({
        type: SAVE_ALERT_RULE_RESPONSE,
        rule: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function addAlertRule(rule) {
  return (dispatch) => {
    dispatch({ type: SAVE_ALERT_RULE_REQUEST, rule })
    axios.post(`${CONFIG.apiBase}/alertrules`, rule).then((response) => {
      dispatch({
        type: SAVE_ALERT_RULE_RESPONSE,
        rule: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
